const trendCardChartCanvas = document.querySelectorAll('.custom-trend-item .trend-chart-canvas');

trendCardChartCanvas.forEach(canvasElement => {
    const trendGraph = JSON.parse(canvasElement.dataset.chartSource);

    new Chart(canvasElement, {
        type: 'line',
        data: {
            labels: trendGraph.map((trendLine) => new Date(trendLine.date || '').toLocaleDateString()),
            datasets: [{
                    data: trendGraph.map((trendLine) => trendLine.relativeFrequency || 0),
                    borderWidth: 1,
                    fill: true,
                    borderColor: '#53049C',
                    backgroundColor: '#53049C',
                    pointRadius: 0,
                    tension: 0.3,
                    hoverRadius: 0,
                    hoverBorderWidth: 0,
                }]
        },
        options: {
            plugins: {
                tooltip: {
                    enabled: false,
                },
                legend: {
                    display: false,
                }
            },
            scales: {
                x: {
                    display: false
                },
                y: {
                    display: false
                }
            }
        }
    });
})
